import React from "react";

const outcomeStyles = {
  pending: "bg-amber-100 text-amber-800",
  failed: "bg-red-100 text-red-800",
  success: "bg-emerald-100 text-emerald-800",
};

const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "-");

// Every try at sending a payout, oldest first: a retry rotates the transfer reference and used to
// leave no trace of the earlier ones. Read-only, from payout.metadata.attempts (append-only).
// Payouts retried before this was recorded show only their earlier references.
const PayoutAttempts = ({ payout }) => {
  const attempts = Array.isArray(payout?.metadata?.attempts) ? payout.metadata.attempts : [];
  const earlier = Array.isArray(payout?.metadata?.previous_transfer_references)
    ? payout.metadata.previous_transfer_references
    : [];
  if (attempts.length === 0 && earlier.length === 0) return null;

  return (
    <div className="mt-6">
      <p className="mb-2 text-xs font-bold tracking-wider text-gray-500 uppercase">Attempts</p>
      {attempts.length > 0 ? (
        <div className="overflow-x-auto rounded border border-gray-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50">
                {["#", "When", "Reference", "Outcome", "By", "Error"].map((h) => (
                  <th key={h} className="px-3 py-2 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {attempts.map((a) => (
                <tr key={`${a.attempt}-${a.transferReference}`}>
                  <td className="px-3 py-2 text-gray-600">{a.attempt}</td>
                  <td className="px-3 py-2 whitespace-nowrap text-gray-600">{when(a.at)}</td>
                  <td className="px-3 py-2 font-mono text-xs text-gray-600 break-all">
                    {a.transferReference}
                    {a.businessPayoutUuid && <span className="block text-gray-400">business payout {a.businessPayoutUuid}</span>}
                  </td>
                  <td className="px-3 py-2">
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${outcomeStyles[a.outcome] ?? "bg-gray-100 text-gray-700"}`}>
                      {a.outcome}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-gray-600">{a.trigger}</td>
                  <td className="px-3 py-2 text-gray-700 break-words">{a.error || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-sm text-gray-600">
          <p className="mb-1 text-xs text-gray-500">Retried before attempts were recorded: earlier references only.</p>
          <ul className="space-y-0.5">
            {earlier.map((ref) => (
              <li key={ref} className="font-mono text-xs break-all">{ref}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PayoutAttempts;
